import { eur } from "@/lib/pricing";
import { fmtDate, statusMeta } from "@/lib/orderStatus";

export default function OrderRow({ order, active, onClick }) {
  const s = statusMeta(order.status);
  return (
    <button
      onClick={onClick}
      className={`grid w-full grid-cols-[auto_1fr_auto] items-center gap-4 border-b border-black/10 px-5 py-4 text-left transition-colors duration-200 ${
        active ? "bg-ink text-white" : "bg-white hover:bg-paper"
      }`}
      data-testid={`order-row-${order.code}`}
    >
      <span className={`h-2.5 w-2.5 rounded-full ${s.dot}`} aria-hidden />
      <span className="min-w-0">
        <span className="block truncate font-display text-sm font-bold tracking-tight">{order.customer.company}</span>
        <span className={`block truncate font-mono text-[10px] uppercase tracking-[0.14em] ${active ? "text-white/55" : "text-ink/45"}`}>
          {order.code} · {fmtDate(order.created_at)} · {order.total_boxes} box
        </span>
      </span>
      <span className="text-right">
        <span className="block font-mono text-sm font-semibold">{eur(order.subtotal)}</span>
        <span className={`block font-mono text-[10px] uppercase tracking-[0.14em] ${active ? "text-white/55" : "text-ink/45"}`} data-testid={`order-row-status-${order.code}`}>
          {s.label}
        </span>
      </span>
    </button>
  );
}
